import { CircularBuffer } from '#common/data-structures';
import { toMicroseconds } from '#common/time';
export class Trace {
    static DEFAULT_MAX_TRACE_EVENTS = 100_000;
    static DEFAULT_CATEGORY = 'default';
    static asyncEventCounter = 0;
    traceEvents;
    constructor(maxTraceEvents = Trace.DEFAULT_MAX_TRACE_EVENTS) {
        if (maxTraceEvents <= 0) {
            throw new RangeError('Max trace events must be greater than 0');
        }
        this.traceEvents = new CircularBuffer(maxTraceEvents);
    }
    getTraceEvents() {
        return this.traceEvents.toArray();
    }
    addCompleteEvent(name, timestampMs, durationMs, category, args) {
        this.traceEvents.push({
            name: name,
            cat: category ?? Trace.DEFAULT_CATEGORY,
            ph: 'X',
            ts: toMicroseconds(timestampMs),
            pid: 1,
            tid: 1,
            args: args ?? {},
            dur: toMicroseconds(durationMs),
        });
    }
    addBeginEvent(name, timestampMs, category, args) {
        this.traceEvents.push({
            name: name,
            cat: category ?? Trace.DEFAULT_CATEGORY,
            ph: 'B',
            ts: toMicroseconds(timestampMs),
            pid: 1,
            tid: 1,
            args: args ?? {},
        });
    }
    addEndEvent(name, timestampMs, category, args) {
        this.traceEvents.push({
            name: name,
            cat: category ?? Trace.DEFAULT_CATEGORY,
            ph: 'E',
            ts: toMicroseconds(timestampMs),
            pid: 1,
            tid: 1,
            args: args ?? {},
        });
    }
    addAsyncEvent(name, timestampMs, durationMs, category, args) {
        category ??= Trace.DEFAULT_CATEGORY;
        args ??= {};
        const asyncEventId = Trace.asyncEventCounter++;
        this.traceEvents.push({
            name: name,
            cat: category,
            ph: 'b',
            ts: toMicroseconds(timestampMs),
            pid: 1,
            tid: 1,
            args: args,
            id: asyncEventId,
        });
        this.traceEvents.push({
            name: name,
            cat: category,
            ph: 'e',
            ts: toMicroseconds(timestampMs + durationMs),
            pid: 1,
            tid: 1,
            args: args,
            id: asyncEventId,
        });
    }
}
